import '@fontsource-variable/nunito';
import './styles/tokens.css';
import { StrictMode, startTransition } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

// A transition render is time-sliced: the first screen mounts under the launch splash without long
// main-thread tasks that would stall the splash animation.
const root = createRoot(document.getElementById('root')!);
startTransition(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});

// PWA: production only (dev and /dev previews never get a service worker).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => undefined); }, { once: true });
}
